import {createSlice} from "@reduxjs/toolkit";

const initialOrdersState = {
    listLoading: false,
    actionsLoading: false,
    totalCount: 0,
    entities: [],
    lastOrder: undefined,
    selectedCategory: null,
    productSearchText: "",
    selectedOrder: undefined
};

export const callTypes = {
    list: "list",
    action: "action"
}

export const ordersSlice = createSlice({
    name: "orders",
    initialState: initialOrdersState,
    reducers: {
        catchError: (state, action) => {
            state.error = `${action.type}: ${action.payload.error}`;
            if (action.payload.callType === callTypes.list) {
                state.listLoading = false;
            } else {
                state.actionsLoading = false;
                state.lastOrder = false;
            }
        },
        startCall: (state, action) => {
            state.error = null;
            if (action.payload.callType === callTypes.list) {
                state.listLoading = true;
            } else {
                state.actionsLoading = true;
            }
        },

        ordersFetched: (state, action) => {
            const {totalCount, entities} = action.payload;
            state.listLoading = false;
            state.error = null;
            state.entities = entities;
            state.totalCount = totalCount;
        },
        
        logsFetched: (state, action) => {
            console.log(action.payload);  
        },

        // CreateOrder
        orderCreated: (state, action) => {
            state.lastOrder = action.payload.order;
            state.actionsLoading = false;
            state.error = null;
            state.entities.push(action.payload.order);
        },

        orderFetched: (state, action) => {
            state.lastOrder = action.payload.order;
            state.actionsLoading = false;
            state.error = null;
        },

        selectedOrderFetched: (state, action) => {
            state.selectedOrder = action.payload.order;
            state.actionsLoading = false;
            state.error = null;
        },

        orderFinalized: (state, action) => {
            state.lastOrder = null;
            state.actionsLoading = false;
            state.error = false;
        },
        orderApproved: (state, action) => {
          state.actionsLoading = false;
          state.error = false;
        },
        
        categoryChanged: (state, action) => {
            state.selectedCategory = action.payload.id;
        },

        searchChanged: (state, action) => {
            state.productSearchText = action.payload.searchText;
        }

    }
})